// #region IMPORT
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

import { BRAND_COLOR } from 'src/theme/core';

import { BrandButton } from 'src/components/custom-button';

import { HeroBackground } from './hero-background';
// #endregion

const FEATURES = [
  {
    title: 'Quản lý',
    key: '0',
  },
  {
    title: 'Giảng dạy',
    key: '1',
  },
  {
    title: 'Học tập',
    key: '2',
  },
];

interface Props {
  onOpenRegisterForm: (value: boolean) => void;
}

const dot = (
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="5" viewBox="0 0 4 5" fill="none">
    <circle cx="2" cy="2.5" r="2" fill="#637381" />
  </svg>
);

export const LandingHero = ({ onOpenRegisterForm }: Props) => {
  const smUp = useResponsive('up', 'sm');
  const customUp = useMediaQuery('(min-width:500px)');
  const customUp2 = useMediaQuery('(min-width:802px)');

  return (
    <Stack position="relative">
      <HeroBackground />
      <Stack
        width={1}
        px={customUp ? 0 : 2}
        justifyContent="center"
        minHeight={{ xs: 500, sm: 700 }}
        height="calc(100vh - 72px)"
        maxHeight={1000}
        zIndex={2}
        pb={{ xs: 10, sm: 20 }}
      >
        {smUp ? (
          <>
            {customUp2 ? (
              <Stack justifyContent="center" alignItems="center" spacing={smUp ? 1.5 : 1}>
                <Typography variant="h1" fontWeight="extrabold" textAlign="center">
                  Phần mềm quản lý trung tâm
                </Typography>
                <Typography
                  variant="h1"
                  fontWeight="extrabold"
                  textAlign="center"
                  sx={{
                    backgroundImage: BRAND_COLOR,
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text', // cho Safari/Chrome
                    color: 'transparent',
                    WebkitTextFillColor: 'transparent', // cho Safari
                    display: 'inline-block', // giúp gradient “bám” theo chữ
                  }}
                >
                  thế hệ mới
                </Typography>
              </Stack>
            ) : (
              <Stack
                mt={customUp ? '50px' : '32.5px'}
                justifyContent="center"
                alignItems="center"
                spacing={smUp ? 1.5 : 1}
              >
                <Typography variant="h1" fontWeight="bold" textAlign="center">
                  Phần mềm quản lý
                </Typography>

                <Typography variant="h1" fontWeight="bold" textAlign="center">
                  trung tâm
                  <Typography
                    component="span"
                    ml={1}
                    variant="h1"
                    fontWeight="bold"
                    textAlign="center"
                    sx={{
                      backgroundImage: BRAND_COLOR,
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text', // cho Safari/Chrome
                      color: 'transparent',
                      WebkitTextFillColor: 'transparent', // cho Safari
                      display: 'inline-block', // giúp gradient “bám” theo chữ
                    }}
                  >
                    thế hệ mới
                  </Typography>
                </Typography>
              </Stack>
            )}
          </>
        ) : (
          <Stack
            mt={customUp ? '50px' : '32.5px'}
            justifyContent="center"
            alignItems="center"
            spacing={smUp ? 1.5 : 1}
          >
            <Typography variant={customUp ? 'h1' : 'h2'} fontWeight="bold" textAlign="center">
              Phần mềm quản lý
            </Typography>{' '}
            <Typography variant={customUp ? 'h1' : 'h2'} fontWeight="bold" textAlign="center">
              trung tâm{' '}
              <Typography
                variant={customUp ? 'h1' : 'h2'}
                fontWeight="bold"
                textAlign="center"
                sx={{
                  backgroundImage: BRAND_COLOR,
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text', // cho Safari/Chrome
                  color: 'transparent',
                  WebkitTextFillColor: 'transparent', // cho Safari
                  display: 'inline-block', // giúp gradient “bám” theo chữ
                }}
              >
                thế hệ mới
              </Typography>{' '}
            </Typography>
          </Stack>
        )}

        <Stack mt={customUp ? 6 : 4} justifyContent="center" alignItems="center" spacing={1}>
          {smUp ? (
            <Stack direction="row" spacing={1.5} justifyContent="center">
              {FEATURES?.map((item) => (
                <Stack key={item.key} direction="row" spacing={1.5}>
                  {item.key !== '0' && <Box>{dot}</Box>}
                  <Typography variant="h6" fontWeight="bold">
                    {item.title}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          ) : (
            <Stack spacing={1} justifyContent="center">
              <Stack direction="row" spacing={1.5}>
                {FEATURES?.slice(0, 3)?.map((item) => (
                  <Stack key={item.key} direction="row" spacing={1.5}>
                    {item.key !== '0' && <Box>{dot}</Box>}
                    <Typography variant="h6" fontWeight="bold">
                      {item.title}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
              <Stack direction="row" spacing={1.5} justifyContent="center">
                {FEATURES?.slice(3, 5)?.map((item) => (
                  <Stack key={item.key} direction="row" spacing={1.5}>
                    {item.key !== '3' && <Box>{dot}</Box>}
                    <Typography variant="h6" fontWeight="bold">
                      {item.title}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          )}

          <Typography variant="h6" fontWeight="light">
            Tất cả trong một nền tảng duy nhất, với AI
          </Typography>
        </Stack>
        <Stack
          spacing={2}
          justifyContent="center"
          alignItems="center"
          py={customUp ? '60px' : '40px'}
        >
          <BrandButton
            size={customUp ? 'large' : 'medium'}
            variant="contained"
            onClick={() => onOpenRegisterForm(true)}
          >
            Đăng ký Demo
          </BrandButton>
        </Stack>
      </Stack>
    </Stack>
  );
};
